// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

// initialize an empty api service that we'll inject endpoints into later as needed
export const dibadminApi = createApi({
    reducerPath: "dibadminApi",
    baseQuery: fetchBaseQuery({baseUrl: "/dibapi"}),
    endpoints: () => ({}),
});
